import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { canonicalUrl } from '../lib/canonical_url'

const canonicalSelector = 'link[data-holic-canonical]'

const CanonicalLink = () => {
  const location = useLocation()

  useEffect(() => {
    const href = canonicalUrl(location.pathname, location.search, window.location.origin)
    const existing = document.head.querySelector<HTMLLinkElement>(canonicalSelector)

    if (!href) {
      existing?.remove()
      return
    }

    const link = existing ?? document.createElement('link')
    link.rel = 'canonical'
    link.dataset.holicCanonical = ''
    link.href = href
    if (!existing) document.head.appendChild(link)
  }, [location.pathname, location.search])

  return null
}

export { CanonicalLink }
